{
	"title": "Privacy Policy",
	"backTitle": "Back"
}
